import { render, staticRenderFns } from "./ASwitchField.vue?vue&type=template&id=e202308a&"
import script from "./ASwitchField.vue?vue&type=script&lang=js&"
export * from "./ASwitchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports